import { render, staticRenderFns } from "./CreateRemittanceMLC.vue?vue&type=template&id=bd034b26&"
import script from "./CreateRemittanceMLC.vue?vue&type=script&lang=ts&"
export * from "./CreateRemittanceMLC.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports